import { render, staticRenderFns } from "./NovaPoshtaTable.vue?vue&type=template&id=32c99f18&scoped=true"
import script from "./NovaPoshtaTable.vue?vue&type=script&lang=js"
export * from "./NovaPoshtaTable.vue?vue&type=script&lang=js"
import style0 from "./NovaPoshtaTable.vue?vue&type=style&index=0&id=32c99f18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c99f18",
  null
  
)

export default component.exports